import React, { useEffect, useState } from 'react';
import { collection, addDoc, query, where, onSnapshot, serverTimestamp } from 'firebase/firestore';
import { firestore } from '../config/firebase';
import defaultProfile from '../assets/default-profile.png';

interface Props {
  teamId: string;
  taskId: string;
  currentUser: { uid: string; displayName?: string | null; photoURL?: string | null };
}

interface Comment {
  id: string;
  text: string;
  userId: string;
  userName?: string;
  photoURL?: string;
  ts: any;
}

const TaskComments: React.FC<Props> = ({ teamId, taskId, currentUser }) => {
  const [comments, setComments] = useState<Comment[]>([]);
  const [input, setInput] = useState('');

  useEffect(()=>{
    const col = collection(firestore, 'kanbanBoards', teamId, 'comments');
    const q = query(col, where('taskId','==',taskId));
    return onSnapshot(q, snap=>{
      const list: Comment[]=[];
      snap.forEach(d=> list.push({ id:d.id, ...(d.data() as any)}));
      list.sort((a,b)=>{
        const ta=(a.ts?.seconds||0);
        const tb=(b.ts?.seconds||0);
        return ta-tb;
      });
      setComments(list);
    });
  }, [teamId,taskId]);

  const handleSend = async ()=>{
    if(!input.trim()) return;
    const col = collection(firestore,'kanbanBoards',teamId,'comments');
    await addDoc(col,{ taskId, text:input.trim(), userId: currentUser.uid, userName: currentUser.displayName||'User', photoURL: currentUser.photoURL||'', ts: serverTimestamp() });
    setInput('');
  };

  return (
    <div className="border-t mt-4 pt-4 max-h-56 overflow-y-auto">
      <h4 className="font-medium mb-2 text-sm">Comments</h4>
      <div className="space-y-3 mb-3">
        {comments.map(c=>(
          <div key={c.id} className="flex gap-2 text-xs">
            <img src={c.photoURL||defaultProfile} alt="avatar" className="w-5 h-5 rounded-full"/>
            <div>
              <p className="font-semibold">{c.userName}</p>
              <p>{c.text}</p>
            </div>
          </div>
        ))}
        {comments.length===0 && <p className="text-xs text-gray-400">No comments yet.</p>}
      </div>
      <div className="flex gap-2">
        <input value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>{if(e.key==='Enter'){handleSend();}}} className="flex-1 border rounded px-2 py-1 text-xs" placeholder="Write a comment..." />
        <button onClick={handleSend} className="px-2 py-1 bg-blue-600 text-white text-xs rounded">Send</button>
      </div>
    </div>
  );
};

export default TaskComments; 